<template>
  <div>
    <Tables ref="tableGridsRelatorioApr"
                :columns= columAPR
                :showSearch="false"
                :showPrint="false"
                :newHeaderStatus="true"
                :showDownload="false"
                :showFullscreen="false"
                v-on:Load="onLoad"
                style="font-family: 'Segoe UI'">
                <tr v-for="(obj,index) in dataRelatoriaAPR" :key="index">
                <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.codigoAPR != null ? obj.codigoAPR: 'N/D'" />
                <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.atividade != null ?  obj.atividade :  'N/D'" />
                <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.local != null ? obj.local: 'N/D'" />
                <TableColumn v-on:Edit="onSelect(obj)" :newState="true" :colorStatus="obj.colorBackgroundStatusApr" :descriptionNewStatus="obj.statusAPRDescricao" :fontColorStatus="obj.colorFontStatusApr" style="font-weight: bold;"></TableColumn>
                <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.nome != null ? obj.nome: 'N/D'" />
                <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="1" :value="obj.dataAPRFormatada != null ? obj.dataAPRFormatada : 'N/D'" />
                <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="1" :value="obj.dataAPRValidadeFormatada != null ? obj.dataAPRValidadeFormatada : 'N/D'" />
                </tr>
                <template #ButtonsAprova>
                <div class="buttons-table-action">
                    <button class="btn-generate-lote" @click="gerarPDF()"><i class="fas fa-file-pdf"></i> EXPORTAR PDF</button>
                </div>
                </template>

    </Tables>
    <AprReportPDF ref="refAprPdf" :formSearch="formSearch"></AprReportPDF>
   </div>

</template>

<script>
import aprReportTable from './aprReportTable'
export default aprReportTable
</script>

  <style scoped>
  .btn-generate-lote {
      height: 2rem;
      padding: 0 1rem;
      background: #008144;
      color: white;
      border-radius: 4px;
      border: none;
      font-size: 12px;
  }
  .btn-generate-lote:hover{
      background: #024d2a;
  }
  .buttons-table-action{
  width: 50vw;
  display: flex;
  justify-content: right;
  align-items: center;
}
  </style>



// WEBPACK FOOTER //
// src/views/private/apr/aprReport/components/aprReportTable/aprReportTable.vue